import React from 'react';

// Possible properties example:
// name: 'button-close'
// children: any
// action: someHandler
// stylePreset:
//      no property             => no preset
//      'dark'                  => full styled button with dark background
//      'disabled'              => disabled button
//      'bordered'              => button with border
//      'no-bordered'           => button without borders
//      'arrow-prev'            => button with left directed animated arrow
//      'arrow-next'            => button with right directed animated arrow
// customStyle:
//      no property             => no custom styles
//      { width: '100px' }      => custom styles object

interface IButton {
    name: string;
    children: any;
    action: (event: React.MouseEvent<HTMLButtonElement>) => void;
    stylePreset?: string;
    customStyle?: any;
}

const Button = ({ name, children, action, stylePreset, customStyle }: IButton) => {
    const defineAdditionalClass = (style: string | undefined) => {
        switch(style) {
            case 'dark':
                return 'isDark';
            case 'disabled':
                return 'isDisabled';
            case 'bordered':
                return 'isBordered';
            case 'no-bordered':
                return 'noBordered';
            case 'arrow-prev':
                return 'isArrowPrev';
            case 'arrow-next':
                return 'isArrowNext';
            default:
                return ''
        }
    };

    const additionalClass = defineAdditionalClass(stylePreset);

    return (
        <button
            className={`custom-button ${additionalClass}`}
            style={customStyle ? customStyle : {}}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => action(event)}
            name={name}
        >
            {additionalClass === 'isArrowPrev'
                ?
                <div className="custom-button__arrow-box">
                    <svg
                        className={`custom-button__arrow ${additionalClass}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="10"
                        viewBox="0 0 7 10"
                        fill="none"
                    >
                        <path
                            d="M5.72314 1L1.73511 5L5.72314 9"
                            stroke=""
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                    <div className={`custom-button__line ${additionalClass}`}/>
                </div>
                :
                ''
            }
            <span className="custom-button__value">{children}</span>
            {additionalClass === 'isArrowNext'
                ?
                <div className="custom-button__arrow-box">
                    <svg
                        className={`custom-button__arrow ${additionalClass}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7 6L2.12712 10.8729C1.6846 11.3154 0.967132 11.3154 0.524611 10.8729C0.0820899 10.4304 0.0820896 9.71289 0.524611 9.27037L3.79498 6L0.524611 2.72963C0.0820899 2.28711 0.0820902 1.56964 0.524611 1.12712C0.967133 0.684601 1.6846 0.684601 2.12712 1.12712L7 6Z"
                            fill=""
                        />
                    </svg>
                    <div className={`custom-button__line ${additionalClass}`}/>
                </div>
                :
                ''
            }
        </button>
    );
};

export default React.memo(Button);
